var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookreact = function SvgFacebookreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 25 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24.001 24.002"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-facebook",
    d: "M24.001 12.074a12 12 0 1 0-13.876 11.928v-8.438H7.076v-3.49h3.049v-2.66c0-3.026 1.79-4.7 4.533-4.7a18.36 18.36 0 0 1 2.687.236v2.97h-1.514a1.74 1.74 0 0 0-1.955 1.886v2.266h3.328l-.532 3.49h-2.8v8.437a12.056 12.056 0 0 0 10.129-11.925Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

export default SvgFacebookreact;